// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes scaleAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale(1.3);
  }
  70% {
    transform: scale(1);
  }
  100% {
    opacity: 1;
  }
}
.bonuses {
  position: relative;
  top: -7vh;
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 480px) {
  .bonuses {
    top: 3vh;
    margin-bottom: 5vh;
  }
}
@media screen and (max-width: 380px) {
  .bonuses {
    top: 3vh;
    margin-bottom: 11vh;
  }
}
.bonuses .container_cards {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
@media screen and (max-width: 991px) {
  .bonuses .container_cards {
    flex-direction: column;
  }
}
.bonuses .container_cards .icon_bonus {
  color: #fff;
  height: 100%;
}
.bonuses .container_cards .icon_bonus h3 {
  margin: 0;
  text-align: center;
  font-family: "Century Gothic";
  font-size: 1.8rem;
}
@media screen and (max-width: 480px) {
  .bonuses .container_cards .icon_bonus h3 {
    font-size: 1.25rem;
    line-height: 1.2em;
  }
}
.bonuses .container_cards .icon_bonus .title_odd {
  font-weight: 600;
}
.bonuses .container_cards .icon_bonus .description {
  padding: 20px 40px;
  text-align: center;
  font-family: "Roboto-Regular";
}
@media screen and (max-width: 991px) {
  .bonuses .container_cards .icon_bonus .description {
    margin-bottom: 20px;
  }
}
.bonuses .container_cards .icon_bonus .image_bonus {
  position: relative;
  z-index: 5;
  margin: 0 auto;
  top: -20px;
  padding: 10px;
  width: 2.5em;
  height: 2.5em;
  border-radius: 50%;
  background-color: inherit;
}
.bonuses .container_cards .icon_bonus .image_bonus img {
  max-width: 40px;
}
.bonuses .container_cards .icon_bonus .image_bonus:hover {
  animation: 1s scaleAnimation ease-out;
}
.bonuses .home .icon_bonus {
  margin: 0 15px;
  padding: 0 15px 50px 15px;
}
@media screen and (min-width: 1921px) {
  .bonuses .home .icon_bonus {
    padding: 30px 70px 70px 70px;
  }
}
@media screen and (max-width: 1920px) {
  .bonuses .home .icon_bonus {
    padding: 0 15px 30px 15px;
  }
}
@media screen and (max-width: 991px) {
  .bonuses .home .icon_bonus {
    padding: 0 15px 25px 15px;
  }
}
.bonuses .home div:nth-child(even) .icon_bonus {
  background-color: #284722;
}
.bonuses .home .icon_bonus {
  background-color: #91b61b;
}
.bonuses .about_job div:nth-child(even) .icon_bonus {
  background-color: #91b61b;
}
.bonuses .about_job .odd {
  height: 100%;
  padding: 0 15px;
  background-color: #284722;
}`, "",{"version":3,"sources":["webpack://./styles/animation.scss","webpack://./src/components/CardsInfo/CardsInfo.scss"],"names":[],"mappings":"AAAA;EACI;IACE,UAAA;ECCJ;EDEE;IACE,UAAA;IACA,qBAAA;ECAJ;EDGE;IACA,mBAAA;ECDF;EDIE;IACE,UAAA;ECFJ;AACF;AAZA;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AAcF;AAZE;EANF;IAOI,QAAA;IACA,kBAAA;EAeF;AACF;AAbE;EAXF;IAYI,QAAA;IACA,mBAAA;EAgBF;AACF;AAdE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAgBJ;AAdI;EALF;IAMI,sBAAA;EAiBJ;AACF;AAfI;EACE,WAAA;EACA,YAAA;AAiBN;AAfM;EACE,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,iBAAA;AAiBR;AAfQ;EANF;IAOI,kBAAA;IACA,kBAAA;EAkBR;AACF;AAfM;EACE,gBAAA;AAiBR;AAZM;EACE,kBAAA;EACA,kBAAA;EACA,6BAAA;AAcR;AAZQ;EALF;IAMI,mBAAA;EAeR;AACF;AAZM;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EAEA,UAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AAaR;AAXQ;EACE,eAAA;AAaV;AATM;EACE,qCAAA;AAWR;AADI;EACE,cAAA;EAEA,yBAAA;AAEN;AAAM;EALF;IAMI,4BAAA;EAGN;AACF;AADM;EATF;IAUI,yBAAA;EAIN;AACF;AAFM;EAbF;IAcI,yBAAA;EAKN;AACF;AAAM;EACE,yBAAA;AAER;AAEI;EACE,yBAAA;AAAN;AAQM;EACE,yBAAA;AANR;AAUI;EACE,YAAA;EACA,eAAA;EACA,yBAAA;AARN","sourcesContent":["@keyframes scaleAnimation {\n    0% {\n      opacity: 1;\n    }\n\n    50% {\n      opacity: 0;\n      transform: scale(1.3);\n\n    }\n    70%{\n    transform: scale(1);\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }","@import '../../../styles/animation.scss';\n\n.bonuses {\n  position: relative;\n  top: -7vh;\n  display: flex;\n  justify-content: center;\n\n  @media screen and (max-width: 480px) {\n    top: 3vh;\n    margin-bottom: 5vh;\n  }\n\n  @media screen and (max-width: 380px) {\n    top: 3vh;\n    margin-bottom: 11vh;\n  }\n\n  .container_cards {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n\n    @media screen and (max-width: 991px) {\n      flex-direction: column;\n    }\n\n    .icon_bonus {\n      color: #fff;\n      height: 100%;\n\n      h3 {\n        margin: 0;\n        text-align: center;\n        font-family: \"Century Gothic\";\n        font-size: 1.8rem;\n\n        @media screen and (max-width: 480px) {\n          font-size: 1.25rem;\n          line-height: 1.2em;\n      }\n      }\n\n      .title_odd {\n        font-weight: 600; \n      }\n\n      // .title_even {}\n\n      .description {\n        padding: 20px 40px;\n        text-align: center;\n        font-family: \"Roboto-Regular\";\n\n        @media screen and (max-width: 991px) {\n          margin-bottom: 20px;\n        }\n      }\n\n      .image_bonus {\n        position: relative;\n        z-index: 5;\n        margin: 0 auto;\n        // top: -60px;\n        top: -20px;\n        padding: 10px;\n        width: 2.5em;\n        height: 2.5em;\n        border-radius: 50%;\n        background-color: inherit;\n\n        img {\n          max-width: 40px;\n        }\n      }\n\n      .image_bonus:hover {\n        animation: 1s scaleAnimation ease-out;\n      }\n    }\n\n\n\n\n  }\n\n  .home {\n    .icon_bonus {\n      margin: 0 15px;\n      // padding: 30px 15px 50px 15px;\n      padding: 0 15px 50px 15px;\n\n      @media screen and (min-width: 1921px) {\n        padding: 30px 70px 70px 70px;\n      }\n\n      @media screen and (max-width: 1920px) {\n        padding: 0 15px 30px 15px;\n      }\n\n      @media screen and (max-width: 991px) {\n        padding: 0 15px 25px 15px;\n      }\n\n    }\n\n    div:nth-child(even) {\n      .icon_bonus {\n        background-color: #284722;\n      }\n    }\n\n    .icon_bonus {\n      background-color: #91b61b;\n    }\n  }\n\n\n  .about_job {\n\n    div:nth-child(even) {\n      .icon_bonus {\n        background-color: #91b61b;\n      }\n    }\n\n    .odd {\n      height: 100%;\n      padding: 0 15px;\n      background-color: #284722;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
